(function () {
  class Freespins {
    constructor() {
      var self = this;
      this._startHolder = undefined;
      this._endHolder = undefined;
      this._fsCountText = undefined;
      this._fsWinningsMeter = undefined;
      this._fsActive = false;
      this._freespinsCount = 0;
      this._spinsLeft = 0;
      this._outroPopup = undefined;
      this._outroPopupButton = undefined;
      this._winningsThisSpin = 0;
      this._gameLoaded = false;
      this._skipOutroMove = false;
      this._waitForPopup = false;

      this._anchorLockPool = [];
      this._anchorLockCreated = 0;
      this._anchorLocks = [];
      this._upgrades = [];
      this._upgradesCreated = 0;

      this.baseGameChestClose = undefined;
      this.bonusBuyChestColour = undefined;
      this.devilLevel = undefined;
      this.isBonusBuy = undefined;

      this._doSpinFunc = this.doSpin.bind(this);
      this._doSpinDeadFunc = this.doSpinDead.bind(this);
      messageBus.subscribe("spinner:GameConfigEvent", this.onGameConfigEvent.bind(this));
      messageBus.subscribe("spinner:FreeSpinsStartEvent", this.onFreespinsStart.bind(this));
      messageBus.subscribe("spinner:FreeSpinsStartEventDead", this.onFreespinsStartDead.bind(this));
      messageBus.subscribe("spinner:FreeSpinsDataEvent", this.onFreespinsData.bind(this));
      messageBus.subscribe("spinner:FreeSpinsDataEventDead", this.onFreespinsDataDeadEvent.bind(this));
      messageBus.subscribe("spinner:FreeSpinsRetriggerEvent", this.onFreespinsRetriggerEvent.bind(this));
      messageBus.subscribe("spinner:FreeSpinsEndEvent", this.onFreespinsEndEvent.bind(this));
      messageBus.subscribe("spinner:FreeSpinsEndEventDead", this.onFreespinsEndEventDead.bind(this));
      messageBus.subscribe("spinner:WinningLinesEvent", this.doPayWins.bind(this));
      this._payWinsDeadFunc = this.doPayWinsDead.bind(this);
      Reflex.registerEventHandler("orientationChange", this.onOrientationChange.bind(this));
      Reflex.registerEventHandler("layoutChange", this.onLayoutChange.bind(this));
      messageBus.subscribe("spinner:FreeSpinsAwardEvent", this.onFreespinsAwarded.bind(this));
      messageBus.subscribe("spinner:FreeSpinsAwardEventDead", this.onFreespinsAwardedEnd.bind(this));
      messageBus.subscribe("freeSpins:removeLocks", this.removeAnchorLocks.bind(this));

      StateMachine.Create(this);
      Reflex.addToUpdate(function (delta, time) {
        self.update(delta, time);
      });

      this.stateMachine.addState("IDLE", function () {});
    }

    update(delta, time) {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }

    onOrientationChange() {
      if (!this._gameLoaded) {
        return;
      }

      const scale = resourceManager.get("slotContainer").scale;

      this._anchorLocks.forEach((anchorLock) => {
        const coord = helpers.getSymbolPos(anchorLock.cell.reel, anchorLock.cell.row);
        anchorLock.anchor.x = coord.x;
        anchorLock.anchor.y = coord.y;
        anchorLock.anchor.scale = scale;
        anchorLock.lock.x = coord.x;
        anchorLock.lock.y = coord.y;
        anchorLock.lock.scale = scale;
        anchorLock.reverseAnchor.x = coord.x;
        anchorLock.reverseAnchor.y = coord.y;
        anchorLock.reverseAnchor.scale = scale;
        anchorLock.reverseLock.x = coord.x;
        anchorLock.reverseLock.y = coord.y;
        anchorLock.reverseLock.scale = scale;
      });

      this._skipOutroMove = true;

      if (this._fsActive) {
        this.updateMeterText(true);
        this.updateButtonPositions(true);
        resourceManager.get("freespinsBacker").visible = true;
      } else {
        this.updateMeterText(false);
        this.updateButtonPositions(false);
        resourceManager.get("freespinsBacker").visible = false;
      }
    }

    onLayoutChange() {
      if (this._winlineTab) {
        if (gameController.inFreeSpins) {
          if (gameController.magicBet) {
            this._winlineTabMagicBet.visible = true;
            this._winlineTabMagicBetPortrait.visible = true;
          } else {
            this._winlineTab.visible = true;
            this._winlineTabPortrait.visible = true;
          }
        } else {
          this._winlineTab.visible = false;
          this._winlineTabPortrait.visible = false;
          this._winlineTabMagicBet.visible = false;
          this._winlineTabMagicBetPortrait.visible = false;
        }
      }
      if (this._fsActive) {
        //const fsCreditMeterPos = resourceManager.get('creditContainer_freespinsPosition').position;
        //this._baseCreditMeterContainer.position.set(fsCreditMeterPos.getX(), fsCreditMeterPos.getY());
        //const fsStakeMeterPos = resourceManager.get('betContainer_freespinsPosition').position;
        //this._baseStakeMeterContainer.position.set(fsStakeMeterPos.getX(), fsStakeMeterPos.getY());

        this.onOrientationChange();
      }
    }

    hideAllAnimations() {}

    onGameConfigEvent() {
      this._gameLoaded = true;

      this._freeSpinsIntroOutro = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro");
      resourceManager.get("freespinsBacker").visible = false;

      this._baseFadeAssets = [
        resourceManager.getContainer("backgroundContainer"),
        resourceManager.get("preReels:reelBackersBase"),
      ];

      this._fsFadeAssets = [resourceManager.get("backgroundAnimatorContainer:fsBackgroundContainer")];

      for (let i = 0; i < this._fsFadeAssets.length; i++) {
        this._fsFadeAssets[i].visible = false;
      }

      this.buttonCreditPanel = resourceManager.get("meterContainer:credit");
      this.buttonWinningsPanel = resourceManager.get("meterContainer:winnings");
      this.buttonStakePanel = resourceManager.get("meterContainer:stake");
      this.buttonFreeSpinPanel = resourceManager.get("meterContainer:freespinsMeterContainer");
      this.buttonFreeSpinValue = resourceManager.get("meterContainer:freespinsMeterContainer:value");
      this.buttonFreeSpinValuePortrait = resourceManager.get("meterContainer:freespinsMeterContainer:valuePortrait");
      this.buttonFreeSpinPanel.visible = false;
      this.collectMeter = resourceManager.get("collectMeterContainer");

      this.updateMeterText(false);
      this.updateButtonPositions(false);
    }

    updateCountText() {
      if (this._fsActive && this._gameLoaded) {
        this.buttonFreeSpinValue.setTranslationParameters(this._freespinsCount - this._spinsLeft, this._freespinsCount);
        this.buttonFreeSpinValuePortrait.setTranslationParameters(
          this._freespinsCount - this._spinsLeft,
          this._freespinsCount
        );
      }
    }

    updateMeterText(inFreeSpins) {
      if (this.buttonCreditPanel && this._gameLoaded) {
        if (inFreeSpins) {
          this.buttonCreditPanel.position = resourceManager.get("meterContainer:creditPosFreeSpins").position;
          this.buttonWinningsPanel.position = resourceManager.get("meterContainer:winningsPosFreeSpins").position;
          this.buttonStakePanel.position = resourceManager.get("meterContainer:stakePosFreeSpins").position;
          // this.buttonFreeSpinPanel.position = resourceManager.get("meterContainer:freeSpinsPosFreeSpins").position;
          this.buttonFreeSpinPanel.visible = true;
        } else {
          this.buttonCreditPanel.position = resourceManager.get("meterContainer:creditPosNormal").position;
          this.buttonWinningsPanel.position = resourceManager.get("meterContainer:winningsPosNormal").position;
          this.buttonStakePanel.position = resourceManager.get("meterContainer:stakePosNormal").position;
          // this.buttonFreeSpinPanel.position = resourceManager.get("meterContainer:freeSpinsPosNormal").position;
          this.buttonFreeSpinPanel.visible = false;
        }
      }
    }

    updateButtonPositions(inFreeSpins) {
      if (!this._gameLoaded) {
        return;
      }

      if (inFreeSpins) {
        if (
          layoutController.getCurrentLayout() === "landscape_mobile" ||
          layoutController.getCurrentLayout() === "landscape_default"
        ) {
          resourceManager.get("buttonContainer:buttonBar:settingsMenu").visible = false;
          resourceManager.get("buttonContainer:buttonBar:stakeButton").visible = false;
          resourceManager.get("buttonContainer:buttonBar:autoplayButton").visible = false;
          resourceManager.get("meterContainer:freespinsMeterContainer:title").visible = true;
          resourceManager.get("meterContainer:freespinsMeterContainer:value").visible = true;
          resourceManager.get("meterContainer:freespinsMeterContainer:titlePortrait").visible = false;
          resourceManager.get("meterContainer:freespinsMeterContainer:valuePortrait").visible = false;
        } else if (
          layoutController.getCurrentLayout() === "portrait_mobile" ||
          layoutController.getCurrentLayout() === "portrait_default"
        ) {
          resourceManager.get("buttonContainer:buttonBar:settingsMenu").visible = false;
          resourceManager.get("buttonContainer:buttonBar:stakeButton").visible = false;
          resourceManager.get("buttonContainer:buttonBar:autoplayButton").visible = false;
          resourceManager.get("meterContainer:freespinsMeterContainer:title").visible = false;
          resourceManager.get("meterContainer:freespinsMeterContainer:value").visible = false;
          resourceManager.get("meterContainer:freespinsMeterContainer:titlePortrait").visible = true;
          resourceManager.get("meterContainer:freespinsMeterContainer:valuePortrait").visible = true;
        }
      } else {
        if (
          layoutController.getCurrentLayout() === "landscape_mobile" ||
          layoutController.getCurrentLayout() === "landscape_default"
        ) {
          resourceManager.get("buttonContainer:buttonBar:settingsMenu").visible = true;
          resourceManager.get("buttonContainer:buttonBar:stakeButton").visible = true;
          resourceManager.get("buttonContainer:buttonBar:autoplayButton").visible = true;
        } else if (
          layoutController.getCurrentLayout() === "portrait_mobile" ||
          layoutController.getCurrentLayout() === "portrait_default"
        ) {
          resourceManager.get("buttonContainer:buttonBar:settingsMenu").visible = true;
          resourceManager.get("buttonContainer:buttonBar:stakeButton").visible = true;
          resourceManager.get("buttonContainer:buttonBar:autoplayButton").visible = true;
        }
      }
    }

    doSpin() {
      this._winningsThisSpin = 0;
      this.updateCountText();
    }

    doSpinDead(spinTask) {}

    getNextSpinOutcome() {
      this.updateCountText();
      gameController.initNewSpin();
      gdk.getNextGameOutcome(function () {});
    }

    onFreespinsStart(task) {
      this.isBonusBuy = task.data.isBonusBuy;

      this.collectMeter.toggleFreeSpinsMeter(true, this.isBonusBuy);

      gameController.slotMachine.clearDimSymbolIds();

      this.baseGameChestClose = gameController.treasureChestClose = task.data.baseGameChestClose;
      this.bonusBuyChestColour = task.data.bonusBuyChestColour;
      this.devilLevel = task.data.devilLevel;
      this.isBonusBuy = task.data.isBonusBuy;
      this.freeSpins = task.data.freeSpins;
      this._spinsLeft = task.data.startFreeSpinsAmt - 1;
      if (this.devilLevel === undefined) {
        debugger;
      }
      console.log(this.devilLevel);
      console.log(gameController.devilLevel);
      gameController.devilLevel = this.devilLevel;

      resourceManager.getController("inputOverlord").setState("freespinsEnabled");
      messageBus.subscribe("spinner:SpinEvent", this._doSpinFunc);
      messageBus.subscribe("spinner:SpinEventDead", this._doSpinDeadFunc);
      messageBus.subscribe("spinner:WinningLinesEventDead", this._payWinsDeadFunc);

      this._winnings = task.data.bonusWin + gameController.preFSReelPrize;

      this._freespinsCount = task.data.startFreeSpinsAmt;
      // this._spinsLeft = task.data.freeSpinsAwarded - 1;

      this._startHolder = task;
      this._startHolder.join();

      this._fsActive = true;

      const self = this;
      timerManager.addTimeout(500, function () {
        self.onDelayedFsStart();

        gameController.reelBorderFire.adjustIntensity(true);
      });
    }

    async onDelayedFsStart() {
      const self = this;

      gameController.centreDevil.dance(true);
      gameController.devilCharacter.dance(-1);
      await new Promise((res) => gsap.delayedCall(1, res));

      const sp = gdk.getServerParser();
      const isRecovery = !!sp._isRecoveryGame;

      if (!this.isBonusBuy || isRecovery) {
        this.updateCountText();
        this.updateMeterText(true);
        gameController.chests.finishAwardingFreeSpins();

        this._freeSpinsIntroOutro.showIntro(self._freespinsCount, function () {
          self.onFSIntroComplete();
        });
      } else {
        //TODO sort levels being passed in
        buyBonusPopup.openChest(
          this.bonusBuyChestColour,
          this._freespinsCount,
          () => {
            self.onFSIntroComplete();
          },
          () => {
            self.updateCountText();
            self.updateMeterText(true);
          }
        );
      }
    }

    onFSIntroComplete() {
      this.updateMeterText(true);
      this.updateButtonPositions(true);
      const self = this;
      
      resourceManager.get("freespinsBacker").visible = true;
      timerManager.addTimer(500, undefined, function () {
        self.freeSpinsTransitionIn();
        
        timerManager.addTimer(gameController.boughtBonus ? 0 : 1500, undefined, function () {
          self._startHolder.leave();
          self._startHolder = undefined;
        });
      });

      if (!this.isBonusBuy) {
        const { left, right } = this.baseGameChestClose;
        gameController.chests.setState({
          leftChestColour: left.hasBeenClosed ? left.newColour : null,
          leftChestSize: null,
          rightChestColour: right.hasBeenClosed && !gameData.encoreEnabled ? right.newColour : null,
          rightChestSize: null,
        });
      }
    }

    onFreespinsStartDead(task) {
      this.getNextSpinOutcome();
    }

    onFreespinsAwarded(task) {}

    freeSpinsTransitionIn() {
      for (let i = 0; i < this._fsFadeAssets.length; i++) {
        gsap.fromTo(
          this._fsFadeAssets[i],
          { visible: true, alpha: 0 },
          {
            alpha: 1,
            duration: 2,
          }
        );
      }
    }

    freeSpinsTransitionOut() {
      for (let i = 0; i < this._fsFadeAssets.length; i++) {
        gsap.fromTo(
          this._fsFadeAssets[i],
          { visible: true, alpha: 1 },
          {
            alpha: 0,
            duration: 1,
            onComplete: () => {
              this._fsFadeAssets[i].visible = false;
            },
          }
        );
      }
    }

    hideReel() {
      let reels = resourceManager.get("slotContainer:reelContainer");

      var bonusID = resourceManager.getConfiguration().symbols["Bonus"].ID;
      let animStrips = [];

      for (var reelID = 0; reelID < reelManager.reels.length; reelID++) {
        var animStrip = resourceManager.get(reelManager.reels[reelID].linkedAnimations[0].name);
        animStrips.push(animStrip);
      }

      timerManager.addTimer(
        300,
        function (progress) {
          animStrips.forEach((strip) => {
            strip.alpha = 1 - progress;
          });

          reels.alpha = 1.0 - progress;
        },
        function () {
          reels.alpha = 0;

          animStrips.forEach((strip) => {
            strip.hideAllAnimations();
          });

          for (var i = 0; i < reelManager.reels.length; i++) {
            for (var j = 0; j < 3; j++) {
              if (reelManager.reels[i].symbolData[j].symbolId === bonusID) {
                gameData.reels[i].showSymbol(j, true);
              }
            }
          }
        }
      );
    }

    onFreespinsAwardedEnd() {
      gdk.getNextGameOutcome(function () {});
    }

    onFreespinsData(task) {
      this.fsSpinWinnings = task.data.fsSpinWinnings;
      this.spinsAdded = task.data.spinsAdded;
      this.spinsRemaining = task.data.spinsRemaining;
      this.totalFsWinnings = task.data.totalFsWinnings;
      this.treasureChestClose = task.data.treasureChestClose;
      timerManager.addTimeout(1800, function () {
        task.leave();
      });

      // this.doFishermanAnimations(true, function () {
      // task.leave();
      // });
    }

    removeAnchorLocks() {
      const self = this;

      // if (this._anchorLocks.length > 0) {
      //   soundManager.play("fishermanRemoveAnchor");
      // }

      this._anchorLocks.forEach((anchorLock) => {
        anchorLock.reverseAnchor.visible = true;
        anchorLock.reverseAnchor.gotoAndPlay(0);
        anchorLock.reverseLock.visible = true;
        anchorLock.reverseLock.gotoAndPlay(0);

        anchorLock.anchor.visible = false;
        anchorLock.lock.visible = false;

        anchorLock.reverseAnchor.onComplete = function () {
          anchorLock.reverseAnchor.visible = false;
          anchorLock.reverseLock.visible = false;

          self._anchorLockPool.push(anchorLock);
        };
      });

      this._anchorLocks = [];
    }

    removeAnchorLocksInstant() {
      this._anchorLocks.forEach((anchorLock) => {
        anchorLock.anchor.visible = false;
        anchorLock.lock.visible = false;
        anchorLock.reverseAnchor.visible = false;
        anchorLock.reverseLock.visible = false;

        this._anchorLockPool.push(anchorLock);
      });

      this._anchorLocks = [];
    }

    getUpgrade() {
      let overlay = undefined;

      if (this._upgrades.length > 0) {
        overlay = this._upgrades.pop();
      } else {
        overlay = resourceManager.createObject("movie", "upgrade" + this._upgradesCreated, "trailFishermenContainer", {
          definition: "upgrade",
          anchor: 0.5,
        });
        overlay.loop = false;
        this._upgradesCreated++;
      }
      return overlay;
    }

    getAnchorLock() {
      let anchorLock = undefined;

      if (this._anchorLockPool.length > 0) {
        anchorLock = this._anchorLockPool.pop();
      } else {
        const anchor = resourceManager.createObject(
          "movie",
          "anchor" + this._anchorLockCreated,
          "fishermenOverlayContainer",
          { definition: "fishermanAnchor", anchor: 0.5 }
        );
        anchor.loop = false;

        const reverseAnchor = resourceManager.createObject(
          "movie",
          "reverseAnchor" + this._anchorLockCreated,
          "fishermenOverlayContainer",
          { definition: "fishermanAnchorReverse", anchor: 0.5 }
        );
        reverseAnchor.loop = false;

        const lock = resourceManager.createObject(
          "movie",
          "lock" + this._anchorLockCreated,
          "fishermenOverlayContainer",
          { definition: "fishermanLock", anchor: 0.5 }
        );
        lock.loop = false;

        const reverseLock = resourceManager.createObject(
          "movie",
          "reverseLock" + this._anchorLockCreated,
          "fishermenOverlayContainer",
          { definition: "fishermanLockReverse", anchor: 0.5 }
        );
        reverseLock.loop = false;

        ++this._anchorLockCreated;

        anchorLock = { anchor, lock, reverseAnchor, reverseLock };
      }
      return anchorLock;
    }

    onFreespinsDataDeadEvent(task) {
      if (task.spinsAdded === 0) {
        this.startNextSpin();
        this._waitForPopup = false;
      } else {
        this._waitForPopup = true;
      }
    }

    startNextSpin() {
      this._spinsLeft--;

      if (this._winningsThisSpin > 0) {
        this.getNextSpinOutcome();
      } else {
        const self = this;
        timerManager.addTimer(450, undefined, function () {
          self.getNextSpinOutcome();
        });
      }
    }

    async onFreespinsRetriggerEvent(task) {
      this._retriggerHolder = task;
      this._retriggerHolder.join();

      const self = this;
      await gameController.handleRetriggerPromise;
      await gameController.chests.finishAwardingRetrigger(task.data.num);
      if (self._waitForPopup) {
        self._waitForPopup = false;
        this._retriggerHolder.leave();

        self.startNextSpin();
      }

      this._spinsLeft += task.data.num;
      this._freespinsCount += task.data.num;

      this.updateCountText();
    }

    doBigWinCheck() {
      let totalWinnings = this._endHolder.data.totalWinnings;

      const bigWinClass = resourceManager.get("bigWin");

      let isBigWin = bigWinClass.willTriggerBigWin(totalWinnings);
      this._fsActive = false;

      if (gameController.boughtBonus) {
        if (totalWinnings <= gameController.globalHelperGetStake()) {
          isBigWin = false;
        }
      }

      if (isBigWin) {
        bigWinClass.start(
          totalWinnings,
          () => {
            this.endFreespins();
            gameController.devilCharacter.idleLoop();
            gameController.reelBorderFire.adjustIntensity(false, true);
          },
          false
        );

        gameController.canSkipWin = true;
      } else {
        this.endFreespins();
        gameController.devilCharacter.idleLoop();
        gameController.reelBorderFire.adjustIntensity(false, true);
      }
    }

    onFreespinsEndEvent(task) {
      const self = this;

      this._endHolder = task;
      this._endHolder.join();

      let isCapped = this._endHolder.data.isCapped.winCapped;

      if (isCapped) {
        const bigWinClass = resourceManager.get("bigWin");

        bigWinClass.showCappedWinPopup(() => {
          self.doOutro();
        });
      } else {
        // this.doFishermanAnimations(false, function () {
        //   self.doOutro();
        // });
        timerManager.addTimeout(1800, function () {
          self.doOutro();
        });
      }
    }

    doOutro() {
      const self = this;

      this._fsActive = false;
      this._skipOutroMove = false;

      messageBus.unsubscribe("spinner:SpinEvent", this._doSpinFunc);
      messageBus.unsubscribe("spinner:WinningLinesEventDead", this._payWinsDeadFunc);
      messageBus.unsubscribe("spinner:SpinEventDead", this._doSpinDeadFunc);

      musicManager.wasInFreeSpins = true;

      this._outroPopup = this._outroPopupWin;
      this._outroPopupButton = this._outroPopupWinButton;
      this.isBonusBuy = false;

      this.updateMeterText(false);
      this.updateButtonPositions(false);
      gameData.winningsMeter.set(this._endHolder.data.totalWinnings);
      gameController.totalWinnings = this._endHolder.data.totalWinnings;
      resourceManager.get("freespinsBacker").visible = false;

      timerManager.addTimeout(1500, function () {
        self.freeSpinsTransitionOut();
      });

      gameController.fsWinnings = this._endHolder.data.fsWinnings;

      this._freeSpinsIntroOutro.showOutro(this._endHolder.data.fsWinnings, function () {
        self.doBigWinCheck();
      });
    }

    endFreespins() {
      this._endHolder.leave();
      this._endHolder = undefined;

      this.collectMeter.toggleFreeSpinsMeter(false);

      resourceManager.getController("inputOverlord").setState("enabled");

      resourceManager.get("chestsContainer")._showBonusChest(false);
      gameController.boughtBonus = false;
    }

    onFreespinsEndEventDead(task) {
      gameData.mainTunePlaying = true;
    }

    doPayWins(task) {
      this._winningsThisSpin = task.data.totalLineWinnings;
    }

    doPayWinsDead(task) {
      this._winnings += task.totalLineWinnings;
    }
  }

  new Freespins();
})();
